import { FC } from "react";
import BFLLink from "@repo/shared-ui/BFLLink";
import BFLImage from "@repo/shared-ui/BFLImage";
import { TopNavItem } from "../../interfaces/IHeader.interface";
import { getAssetUrl } from "./assetUrl";

const RightMenu: FC<{ navRightItems?: TopNavItem[] }> = ({ navRightItems }) => {
  return (
    <ul data-testid="right-menu-container" className="flex items-center gap-2">
      {navRightItems && navRightItems.length > 0
        ? navRightItems.map((value, idx) => (
            <li key={idx}>
              <BFLLink
                className={`md-px-0 flex items-center bg-gray-900 py-[7px] md:text-[12px] lg:px-2 lg:text-xs font-medium max-h-[28px] rounded ${
                  idx === 0 ? "bg-bfl-blue" : ""
                }`}
                href={value?.ctaLink}
                openInNewTab={value?.openInNewTab}
              >
                <BFLImage
                  src={getAssetUrl(value?.image) || "/images/logo.png"}
                  alt={value?.imageAltText ?? "Navigation image"}
                  width={12}
                  height={13}
                  className="mr-[5px]"
                  unoptimized={true}
                />
                <span className="min-w-fit">{value.title}</span>
              </BFLLink>
            </li>
          ))
        : null}
    </ul>
  );
};

export default RightMenu;
